import { useGetArtworkSets } from "@/api/ensemble/ensemble";
import { Ensemble } from "@/lib/types";
import { isValidElement, useCallback } from "react";
import { MenuItem } from "../ui/menuitem";
import { useAdditionalFilters } from "@/context/additional-filters/AdditionalFiltersContext";
import { useLocation } from "react-router-dom";

type ArtworkSetsMenuSectionProps = {
  title: React.ReactNode;
  visibility: Ensemble["visibility"];
};

const ArtworkSetsMenuSection = ({
  title,
  visibility,
}: ArtworkSetsMenuSectionProps) => {
  const filters = useAdditionalFilters();

  const location = useLocation();

  const { data: sets } = useGetArtworkSets({ visibility });

  const isActive = useCallback(
    (pageSetId: string) => filters?.setId === pageSetId,
    [filters?.setId],
  );

  return (
    <div className="flex flex-col">
      {isValidElement(title) ? (
        title
      ) : (
        <span className="py-3 px-6 font-bold text-sm">{title}</span>
      )}

      {sets?.map((set) => (
        <MenuItem
          to={{
            search: location.search,
          }}
          key={set.id}
          onClick={() => {
            if (set.id === filters?.setId) {
              filters?.setSetId(undefined);
              return;
            }
            filters?.setSetId(set.id);
          }}
          number={set.artworkCount}
          name={set.ensemblesDescriptionNomEnsemble}
          forcedActive={isActive(set.id)}
        />
      ))}
    </div>
  );
};

export default ArtworkSetsMenuSection;
